import request from '@/utils/request'

let Ma_accident_reportingApi = {

  /*事故上报列表*/
  list(data) {
    return request._post('/shop/plus.ma_accident_reporting.Index/index', data);
},
/*添加事故上报*/
add(data) {
    return request._post('/shop/plus.ma_accident_reporting.Index/add', data);
},
/*修改事故上报*/
edit(data) {
    return request._post('/shop/plus.ma_accident_reporting.Index/edit', data);
},
/*删除事故上报*/
del(data) {
    return request._post('/shop/plus.ma_accident_reporting.Index/del', data);
},
/*事故上报详情*/
detail(data) {
  return request._post('/shop/plus.ma_accident_reporting.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_accident_reporting.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_accident_reporting.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_accident_reporting.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_accident_reporting.Index/export', data);
    },
}
export default Ma_accident_reportingApi;



// WEBPACK FOOTER //
// ./src/api/ma_accident_reporting.js